"use strict";

jQuery(document).on('click', '[js-href-popup]', function (evt) {
    evt.preventDefault();
    window.open($(this).attr('href'), "_blank", "height=950,width=965,scrollbars=no,resizable=yes");
});
